import React from 'react';
import { uniqueId } from 'lodash-es';
import { Box } from '@apia/theme';
import { menuController, IMenuDefinition } from '../menuController';

type TAsideLoader = Partial<IMenuDefinition> & {
  children: React.ReactNode;
  variant?: string;
};

export const AsideLoader = (definition: TAsideLoader) => {
  React.useEffect(() => {
    const variant = definition.variant ?? 'twoColumnsAside';

    const unregister = menuController.setMenu({
      menu: (
        <Box className="ApplicationMenu" variant={`layout.${variant}`}>
          {definition.menu ?? definition.children}
        </Box>
      ),
      stage: definition.stage ?? uniqueId(),
    });

    return () => {
      unregister();
    };
  }, [
    definition.children,
    definition.menu,
    definition.stage,
    definition.variant,
  ]);

  return null;
};
